import { Component, OnInit, Directive, Input, HostListener, ViewChild } from '@angular/core';

import { FormBuilder, FormControl, FormGroup, Validators, NgControl } from '@angular/forms';
import { Router } from '@angular/router';
import { EguardConfigService } from '../../../../core/services/config.service';
import { eguardAnimations } from '../../../../core/animations';
import { CognitoUtil } from '../../../shared/services/cognito.service';
import { CaseActionComponent } from '../../common/case-action/case-action.component';
import { MatDialog } from '@angular/material';
import { MatSnackBar } from '@angular/material';
import { ReportsService } from '../../../shared/services/reports.service';
import { Subject } from 'rxjs/Subject';
import { HeaderTitleService } from 'app/services/header-title.service';
@Component({
    selector: 'reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {

    view: any[] = [null, 400];

    showTable = false;
    showPendingCasesTable = false;
    // options

    orgId = null;
    userId = null;

    colorScheme = {
        domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA']
    };

    selectedTab = 0;

    // pie
    explodeSlices = false;

    toolTipGenerator = function (event) {
        let text;
        if (event && event.data) {
            text = `${event.data.name} - ${event.data.value}`;
        }
        return text;
    };

    userAttributes: Subject<any> = new Subject();

    constructor(
        private eguardConfig: EguardConfigService, private reportsService: ReportsService,
        private router: Router, private cognitoUtil: CognitoUtil,
        private headerService: HeaderTitleService
    ) {

        this.eguardConfig.setSettings({
            layout: {
                navigation: 'left', // 'right', 'left', 'top', 'none'
                toolbar: 'below', // 'above', 'below', 'none'
                footer: 'none', // 'above', 'below', 'none'
                mode: 'fullwidth' // 'boxed', 'fullwidth'
            },
            customScrollbars: true,
            routerAnimation: 'fadeIn',
            themeOption: true
        });
    }

    ngOnInit() {
        this.cognitoUtil.getUserAttributes(this);
        setTimeout(() => { this.sendHeaders(); });
    }
    sendHeaders(): void {
        this.headerService.sendHeader('bar_chart', 'Reports')
    }

    chartTabChange(event) {
        this.selectedTab = event.index
        this.showTable = false;
        this.showPendingCasesTable = false;
    }

    toggleExpandRow(row, tableType) {
        this[tableType].rowDetail.toggleExpandRow(row);
    }

    onDetailToggle(event) {
    }

    openCase(row) {
        // this.router.navigate(['case', this.org, id]);
    }

    cognitoCallback(message: string, result: any) {
        switch (message) {
            case 'User Attr':
                this.userId = result.filter(function (obj) {
                    return obj.Name === 'sub';
                })[0].Value;

                this.orgId = result.filter(function (obj) {
                    return obj.Name === 'custom:organization';
                })[0].Value;
                this.userAttributes.next(result);
                break;
            case 'Session Error':
                this.router.navigate(['/login']);
                break;
        }

    }

}



// WEBPACK FOOTER //
// ./src/app/main/content/common/reports/reports.component.ts